(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aboutus"] && !Shopify.designMode) return;
  try {
    
(function(){
  function formatNumber(n, fmt){
    n = Math.round(n);
    if(fmt === 'comma'){
      return n.toLocaleString('en-US');
    }
    return String(n);
  }
  function animateCount(el){
    var target = parseFloat(el.getAttribute('data-target')) || 0;
    var suffix = el.getAttribute('data-suffix') || '';
    var fmt = el.getAttribute('data-format') || '';
    var duration = 1400;
    var start = null;
    function ease(t){ return 1 - Math.pow(1 - t, 3); }
    function step(ts){
      if(start === null) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = ease(progress);
      var current = target * eased;
      el.textContent = formatNumber(current, fmt) + suffix;
      if(progress < 1){
        window.requestAnimationFrame(step);
      } else {
        el.textContent = formatNumber(target, fmt) + suffix;
      }
    }
    window.requestAnimationFrame(step);
  }

  function initRoot(root){
    if(root.getAttribute('data-animate') === 'false'){
      return;
    }
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var counters = root.querySelectorAll('.trv-ed-count');
    if(counters.length){
      if(reduceMotion || !('IntersectionObserver' in window)){
        counters.forEach(function(el){
          animateCount(el);
          var stat = el.closest('.trv-ed-stat');
          if(stat){ stat.classList.add('is-counted'); }
        });
      } else {
        var seen = new WeakSet();
        var countObserver = new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            if(entry.isIntersecting && !seen.has(entry.target)){
              seen.add(entry.target);
              animateCount(entry.target);
              var stat = entry.target.closest('.trv-ed-stat');
              if(stat){ stat.classList.add('is-counted'); }
              countObserver.unobserve(entry.target);
            }
          });
        }, { threshold: 0.4 });
        counters.forEach(function(el){ countObserver.observe(el); });
      }
    }

    var reveals = root.querySelectorAll('.reveal, .reveal-stagger');
    if(reveals.length){
      if(reduceMotion || !('IntersectionObserver' in window)){
        reveals.forEach(function(el){ el.classList.add('is-visible'); });
      } else {
        var revealObserver = new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            if(entry.isIntersecting){
              entry.target.classList.add('is-visible');
              revealObserver.unobserve(entry.target);
            }
          });
        }, { threshold: 0.2, rootMargin: '0px 0px -40px 0px' });
        reveals.forEach(function(el){ revealObserver.observe(el); });
      }
    }
  }

  document.querySelectorAll('.trv-ed').forEach(initRoot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-header-photo-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initRoot(root){
    if(root.getAttribute('data-animate') === 'false'){
      return;
    }
    var reveals = root.querySelectorAll('.reveal');
    if(!reveals.length) return;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(reduceMotion || !('IntersectionObserver' in window)){
      reveals.forEach(function(el){ el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    reveals.forEach(function(el){ observer.observe(el); });
  }
  document.querySelectorAll('.trv-ph').forEach(initRoot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["travure-stats-v1"] && !Shopify.designMode) return;
  try {
    
  class TvStatsBar extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;

      this.track = this.querySelector('.tv-stats__track');
      this.viewport = this.querySelector('.tv-stats__viewport');
      this.group = this.querySelector('[data-stats-group]');
      this.set = this.querySelector('[data-stats-set]');
      if (!this.track || !this.group || !this.set) return;

      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.countEnabled = this.dataset.countUp === 'true' && !this.reduced;
      this.marqueeEnabled = this.dataset.marquee === 'true' && !this.reduced;
      this.speed = parseFloat(this.dataset.speed) || 55;
      this.countDuration = parseInt(this.dataset.countDuration, 10) || 1800;
      this.delay = parseInt(this.dataset.delay, 10) || 0;
      this.thousands = this.dataset.thousands || '';
      this.decimal = this.dataset.decimal || ',';

      this.numbers = Array.from(this.querySelectorAll('[data-stat-value]'));
      this.finals = this.numbers.map((el) => el.querySelector('[data-stat-number]').textContent);

      if (this.countEnabled) {
        this.numbers.forEach((el, i) => {
          el.querySelector('[data-stat-number]').textContent = this.format(0, this.decimalsOf(i));
        });
      }

      this.layout();
      this.observe();

      // Alleen reageren als de breedte echt verandert. Op mobiel vuurt
      // 'resize' ook bij het in- en uitschuiven van de adresbalk, en dan
      // zou de marquee onnodig opnieuw opstarten (zichtbare hapering).
      this.lastWidth = window.innerWidth;
      this.onResize = this.debounce(() => {
        if (window.innerWidth === this.lastWidth) return;
        this.lastWidth = window.innerWidth;
        this.relayout();
      }, 250);
      window.addEventListener('resize', this.onResize);

      document.addEventListener('shopify:block:select', (e) => {
        if (this.contains(e.target)) this.setAttribute('data-paused', 'true');
      });
      document.addEventListener('shopify:block:deselect', (e) => {
        if (this.contains(e.target)) this.removeAttribute('data-paused');
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      if (this.io) this.io.disconnect();
    }

    decimalsOf(i) {
      return parseInt(this.numbers[i].dataset.statDecimals, 10) || 0;
    }

    /* Bepaal of alles naast elkaar past; zo niet, meteen scrollen. */
    layout() {
      this.setAttribute('data-state', 'measure');
      const natural = this.set.getBoundingClientRect().width;
      const available = this.viewport.getBoundingClientRect().width;
      this.fitsOnOneRow = natural <= available - 1;
      this.setAttribute('data-state', this.fitsOnOneRow ? 'grid' : 'measure');
    }

    observe() {
      this.io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting || this.started) return;
            this.started = true;
            this.io.disconnect();
            this.start();
          });
        },
        { threshold: 0.25 }
      );
      this.io.observe(this);
    }

    /* Volgorde is belangrijk: eerst tellen, pas daarna klonen. Zou de marquee
       eerder starten, dan blijven de kopieën op 0 staan. */
    start() {
      const begin = () => {
        if (!this.marqueeEnabled) return;
        if (this.fitsOnOneRow) this.freezeWidths();
        this.startMarquee();
      };

      if (!this.countEnabled) {
        begin();
        return;
      }

      this.countUp(() => {
        window.setTimeout(begin, this.delay);
      });
    }

    /* Legt de breedtes uit de grid-weergave vast, zodat de overgang
       naar de marquee geen sprong veroorzaakt. */
    freezeWidths() {
      this.querySelectorAll('.tv-stats__item').forEach((item) => {
        item.style.width = Math.round(item.getBoundingClientRect().width) + 'px';
      });
    }

    /* Bouwt één groep die minstens de viewport vult en dupliceert die groep
       daarna precies één keer. De track bestaat dan uit twee identieke
       helften, waardoor de animatie op een vaste -50% kan lopen. */
    startMarquee() {
      this.resetClones();
      this.setAttribute('data-state', 'marquee');

      const setWidth = this.set.getBoundingClientRect().width;
      const viewportWidth = this.viewport.getBoundingClientRect().width;
      if (!setWidth) return;

      const copies = Math.max(1, Math.ceil(viewportWidth / setWidth));
      for (let i = 1; i < copies; i++) {
        this.group.appendChild(this.makeClone(this.set));
      }

      const groupWidth = this.group.getBoundingClientRect().width;
      this.track.appendChild(this.makeClone(this.group));

      this.track.style.setProperty('--tv-dur', groupWidth / this.speed + 's');
    }

    makeClone(node) {
      const clone = node.cloneNode(true);
      clone.removeAttribute('data-stats-set');
      clone.removeAttribute('data-stats-group');
      clone.setAttribute('data-stats-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[id]').forEach((n) => n.removeAttribute('id'));
      clone.querySelectorAll('[data-stats-set], [data-stats-group]').forEach((n) => {
        n.removeAttribute('data-stats-set');
        n.removeAttribute('data-stats-group');
      });
      return clone;
    }

    resetClones() {
      this.querySelectorAll('[data-stats-clone]').forEach((n) => n.remove());
    }

    relayout() {
      const wasMarquee = this.getAttribute('data-state') === 'marquee';
      this.resetClones();
      this.querySelectorAll('.tv-stats__item').forEach((i) => (i.style.width = ''));
      this.layout();
      if (!wasMarquee) return;
      if (this.fitsOnOneRow) this.freezeWidths();
      this.startMarquee();
    }

    countUp(done) {
      const start = performance.now();
      const duration = this.countDuration;
      const targets = this.numbers.map((el) => parseFloat(el.dataset.statValue) || 0);

      const tick = (now) => {
        const p = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - p, 4);
        this.numbers.forEach((el, i) => {
          const d = this.decimalsOf(i);
          el.querySelector('[data-stat-number]').textContent =
            p === 1 ? this.finals[i] : this.format(targets[i] * eased, d);
        });
        if (p < 1) {
          requestAnimationFrame(tick);
        } else if (typeof done === 'function') {
          done();
        }
      };
      requestAnimationFrame(tick);
    }

    format(value, decimals) {
      const fixed = value.toFixed(decimals);
      const parts = fixed.split('.');
      let int = parts[0];
      if (this.thousands) {
        int = int.replace(/\B(?=(\d{3})+(?!\d))/g, this.thousands);
      }
      return parts.length > 1 ? int + this.decimal + parts[1] : int;
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }

  if (!customElements.get('tv-stats-bar')) {
    customElements.define('tv-stats-bar', TvStatsBar);
  }

  } catch(e) { console.error(e); }
})();
})();
